<ul class="custom-bread-crumb">
  @for (bc of breadcrumbs; track bc; let last = $last; let i = $index) {
    <li>
      @if (!last) {
        <a [routerLink]="bc.url || '/home'" [class.root]="i === 0">
          {{ bc.label }}
        </a>
        <span class="separator">/</span>
      }
      @if (last) {
        <span [class.root]="i === 0">{{ bc.label }}</span>
      }
    </li>
  }
</ul>